import { render, staticRenderFns } from "./InstructionParameterMatrix.vue?vue&type=template&id=f94a46f6&"
import script from "./InstructionParameterMatrix.vue?vue&type=script&lang=js&"
export * from "./InstructionParameterMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports